import React from 'react'

import { BaseAddDirectDebitMethodButton } from './BaseAddDirectDebitMethodButton'

export const AddDirectDebitPAD: React.FC = () => {
  return <BaseAddDirectDebitMethodButton i18nKey='addDirectDebitEFT' />
}
